export default {
  title: 'Gebyrer',
  subtitle: 'Hos enkel har vi transparente priser. Nedenfor kan du se, hvilke gebyrer der kan være ved forskellige situationer.',
  intro: 'Vi bestræber os generelt på ikke at have gebyrer på vores kerneprodukter.',
  tableService: 'Ydelse',
  tableFee: 'Gebyr (inkl. moms)',
  tableStatus: 'Status',
  free: 'Gratis',
  feeLabel: 'Gebyr',
  whatMeans: 'Hvad betyder dette?',
  reminderFee2: 'Hvis du ikke betaler din faktura til tiden, sender vi en påmindelse. Først sender vi en gratis 1. rykker. Hvis du stadig ikke betaler, sender vi en 2. rykker med et gebyr på 125 kr. inkl. moms.',
  installmentPlanFee: 'Hvis du har brug for at indgå en afdragsordning for ubetalte fakturaer, er der et gebyr på 125 kr. inkl. moms for at oprette ordningen.',
  noHiddenTitle: 'Ingen skjulte omkostninger',
  noHiddenText: 'Vi tror på gennemsigtighed. Derfor har vi ingen skjulte gebyrer eller abonnementsomkostninger. De eneste gebyrer, du kan støde på, er dem der er listet ovenfor - og de fleste af dem er 0 kr.',
  questionsTitle: 'Har du spørgsmål til vores gebyrer?',
  questionsSubtitle: 'Kontakt os gerne, så hjælper vi dig videre',
  feeSetupFee: 'Oprettelsesgebyr',
  feeSetupOnline: 'Oprettelsesgebyr online',
  feeSetupClosureOrOutage: 'Oprettelsesgebyr ved skifte på grund af lukkevarsel eller afbrudt strøm',
  feeCompensation: 'Kompensationsgebyr',
  feeCancellation: 'Opsigelsesgebyr',
  feePowerOn: 'Åbning af strøm',
  feeReminder1: 'Rykkergebyr ved 1. rykker',
  feeReminder2: 'Rykkergebyr ved 2. rykker',
  feeInstallmentPlan: 'Oprettelse af afdragsordning',
};